import {IS_CLIENT_SIDE} from '../../../../common/shared/utils/constants';
import {isTrue} from '../../../../common/shared/utils/isTrue';

export function getTicketPopupOn() {
  if (!IS_CLIENT_SIDE) {
    return undefined;
  }
  const popupOn = window.localStorage.getItem(LOCAL_STORAGE_KEY);
  // 24년 6차 스프린트 이후 이용권 사용확인 디폴트값 On으로 변경
  if (!popupOn) {
    return true;
  }
  return isTrue(popupOn);
}

export function saveTicketPopupOn(popupOn: boolean) {
  if (!IS_CLIENT_SIDE) {
    return undefined;
  }
  window.localStorage.setItem(LOCAL_STORAGE_KEY, String(popupOn));
}

/** 이용권 사용확인 기능 끄기 여부 값입니다. */
const LOCAL_STORAGE_KEY = 'kp_ticket_popup_on';
